<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { QuickCategoriesIdType } from '../../Planning/QuickCategories/QuickCategoriesConfig';
    import { QuickCategories } from '../../Planning/QuickCategories/QuickCategories';
    import { quickCategoriesConfig } from '../../Planning/QuickCategories/QuickCategoriesConfig';
    import IconRouteCompleted from '../../../shared/Icons/IconRouteCompleted.svelte';
    import IconRouteInProgress from '../../../shared/Icons/IconRouteInProgress.svelte';
    import { availableProcessStages } from '../../../../stores/Const';

    export let categoryId: QuickCategoriesIdType = 'to_approve';
    export let showStartArrow: boolean = false;
    export let showEndArrow: boolean = false;
    export let wider: boolean = false;
    export let wider2: boolean = false;
    export let showValue: boolean = true;
    export let title: string = '';
    export let status: number | null = null;

    let value: string = '';
    let currentColor: string = '';
    let currentBackgroundColor: string = '';
    let qc: QuickCategories = new QuickCategories(quickCategoriesConfig);

    $: currentColor = qc.getColor(categoryId);
    $: currentBackgroundColor = qc.getBackgroundColor(categoryId);
    $: {
        value = showValue ? '⚫' : '';
    }

    //        {:else if status === 6} <IconRouteCompleted scale={0.7} />
</script>

<div style="display: flex; flex-direction: row; align-items: center;">
    {#if showStartArrow}
        <div
            class="arrow-right-start"
            style="border-bottom-color: {currentBackgroundColor}; border-top-color: {currentBackgroundColor};border-left-color: transparent;"
        ></div>
    {/if}
    <div
        class:bold={true}
        class:withColor={true}
        class:wider
        class:wider2
        style={'background-color: ' +
            currentBackgroundColor +
            '; color: ' +
            currentColor +
            '; font-weight: 600; position: relative;'}
        {title}
    >
        {#if availableProcessStages.find(s => s?.name === 'in_delivery')?.id === status && false}
            <IconRouteInProgress scale={0.7} {title} />
        {:else if availableProcessStages.find(s => s?.name === 'delivered')?.id === status && false}
            <IconRouteCompleted scale={0.7} {title} />
        {:else}
            <div style="position: absolute;">
                {value}
            </div>
        {/if}
    </div>
    {#if showEndArrow}
        <div class="arrow-right-end" style="border-left-color: {currentBackgroundColor}"></div>
    {/if}
</div>

<style>
    .withColor {
        min-width: 6px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        line-height: 16px;
        height: 17px;
        font-size: 6px;
    }
    .arrow-right-end,
    .arrow-right-start {
        width: 0;
        height: 0;
        border-top: 9px solid transparent;
        border-bottom: 8.5px solid transparent;
        border-left: 3px solid transparent;
    }
    .wider {
        min-width: 75px;
        display: flex;
        justify-content: center;
    }
    .wider2 {
        min-width: 18px;
        display: flex;
        justify-content: center;
    }
</style>
